import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';
import { NationalityModel, TasdekCountries } from '@/shared/components/IdentityTypesComponents/Model/NationalityModel';

//@Module({ namespaced: true })
@Module({})
export default class LookupStore extends VuexModule {
  _nationalities: NationalityModel[] = [];
  _tasdekCountriesLst: TasdekCountries[] = [];
  _tasdekSourceCountriesLst: TasdekCountries[] = [];

  get getNationalities(): any {
    return this._nationalities;
  }

  get getGCCNationalities(): any {
    if (this._nationalities.length > 0) {
      return this._nationalities.filter(
        (s) => s.id == 4 || s.id == 5 || s.id == 6 || s.id == 7 || s.id == 9
      );
    } else {
      return this._tasdekCountriesLst.filter(
        (s) => s.id == 4 || s.id == 5 || s.id == 6 || s.id == 7 || s.id == 9
      );
    }
  }

  get getTasdekCountries(): TasdekCountries[] {
    return this._tasdekCountriesLst;
  }

  get getTasdekSourceCountriesLst(): TasdekCountries[] {
    return this._tasdekSourceCountriesLst;
  }

  @Mutation
  public setNationalities(payload: NationalityModel[]): void {
    this._nationalities = payload;
  }

  @Mutation
  public updateTasdekCountriesMut(value: TasdekCountries[]): void {
    this._tasdekCountriesLst = value;
  }

  @Mutation
  public setTasdekSourceCountriesLst(value: TasdekCountries[]): void {
    this._tasdekSourceCountriesLst = value;
  }

  @Action
  public updateTasdekCountries(value: TasdekCountries[]) {
    this.context.commit('updateTasdekCountriesMut', value);
  }


  @Action
  public updateNationalities(payload: string): void {
    this.context.commit('setNationalities', payload);
  }

  @Action
  public updateTasdekSourceCountriesLst(payload: TasdekCountries[]): void {
    this.context.commit('setTasdekSourceCountriesLst', payload);
  }
}
// export default UserStore;
